import { Component, Input, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../../globals';
import { DeliberyNoteServices } from '../../../../delibery_note/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the ProductPartialFoodcostIngSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-expenses-deno-partial-deno-select',
  templateUrl: 'expenses-deno-partial-deno-select.html',
})
export class ExpensesDenoPartialDenoSelectPage {
  term: string;
  @Input() denos;
  //datatable
  sorts = [
    { prop: 'number', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public globals: Globals,
    private deliberyNoteServices: DeliberyNoteServices,
    public translate: TranslateService) {
  }

  insert(deno) {

    //inicialirtzar sin proveedor

    if (!this.check(deno.UID)) { //Buscamos si el deno ya esta anadido
      var _array = Array();
      _array.push(deno.UID);
      _array.push(this.globals.timestampToDate(deno.date));
      _array.push(deno.list);
      _array.push(deno.number);
      _array.push(deno.provider_static);
      _array.push(deno.uid_provider);
      _array.push(deno.uid_provider_order);
      _array.push(deno.total);
      this.deliberyNoteServices.delibery_notes_array_tmp.push(_array);
      this.deliberyNoteServices.delibery_notes_array_tmp = [...this.deliberyNoteServices.delibery_notes_array_tmp];

      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-albaran') + ' ' + deno.number + ' ' + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-albaran-esta-anadido-lista'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  check(value) {
    var response = false;
    for (var i = 0; i < this.deliberyNoteServices.delibery_notes_array_tmp.length; i++) {
      var obj = this.deliberyNoteServices.delibery_notes_array_tmp[i];
      if (obj[0] == value) {
        response = true;
      }
    }
    return response;
  }
  clickElement(event) {
    if (event.type == 'click') {
      this.insert(event.row);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-partial-deno-select/expenses-deno-partial-deno-select.ts